module.exports = __webpack_public_path__ + "a64599bf3bcbbc70e050470e78bafe34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2_2023_chart.png
// module id = 1716
// module chunks = 0